import React, { Component } from "react";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import successCar from "../../assets/images/animations/Succes.json";
import errorCar from "../../assets/images/animations/Error.json";
import { mailIcon } from "../../common/utils/images";
import LoanConfirmationDetail from "../../common/components/pageBlocks/confirmation/loanConfirmationDetail";
import FormStep from "../../common/components/formStep";
import LottieAnimation from "../../common/components/lottieAnimation";
import commonContext, { AppContext } from "../../common/context/common";
import { Zd10SecApis } from "../apis/zd10SecApis";
import { leadType } from "../../app";

interface IProps {
    history: any;
}
interface IState {
    status: boolean;
    applicationNumber: string;
    carModel: string;
}
class Confirmation extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    apis: Zd10SecApis;
    setLead: Function;
    steps = [
        { title: "Vehicle" },
        { title: "Loan" },
        { title: "Review" },
        { title: "Personal" },
    ];
    constructor(props: IProps) {
        super(props);
        this.state = {
            status: true,
            applicationNumber: "",
            carModel: "Maruti Baleno",
        };
    }
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.apis = (this.context as AppContext).apis as Zd10SecApis;
        this.setLead = (this.context as AppContext).setLead;
        this.lead = (this.context as AppContext).lead as leadType;
        const apiData = await this.apis.successDetails(this.lead);
        if (
            this.context?.lead?.modelDescription &&
            this.context?.lead?.uniqueReferenceNo
        ) {
            this.setState({
                carModel: this.context.lead.modelDescription,
                applicationNumber: this.context.lead.uniqueReferenceNo,
            });
        }
        this.setLead(apiData.result);
    }
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="confirm-wrap mt-110">
                        <div className="container mx-auto px-5">
                            <FormStep
                                steps={[
                                    ...this.steps,
                                    {
                                        title: "Confirmation",
                                        active: true,
                                        failed: !this.lead.confirmStatus,
                                    },
                                ]}
                            />

                            <div className="congrats-screen w-full">
                                <div className="flex justify-center mx-auto car-img-wrap mb-3 md:mb-6">
                                    <LottieAnimation
                                        width={230}
                                        height={180}
                                        animationData={
                                            this.lead.confirmStatus
                                                ? successCar
                                                : errorCar
                                        }
                                    />
                                </div>
                                <h1 className="text-center text-gray-2 font-42px openSans-Light mt-3 w-10/12 mx-auto">
                                    {this.lead.confirmStatus ? (
                                        <>
                                            Your loan
                                            <span className="openSans-SemiBold bigg">
                                                #{this.state.applicationNumber}
                                            </span>
                                            for{" "}
                                            <span className="openSans-SemiBold bigg">
                                                {this.lead.manufacturer}{" "}
                                                {this.lead.make}{" "}
                                                {this.lead.model}
                                            </span>
                                            has been disbursed!
                                        </>
                                    ) : (
                                        <>
                                            There seems to be an issue with your
                                            loan application
                                            <span className="openSans-SemiBold bigg">
                                                #{this.state.applicationNumber}
                                            </span>
                                            for{" "}
                                            <span className="openSans-SemiBold bigg">
                                                {this.lead.manufacturer}{" "}
                                                {this.lead.make}{" "}
                                                {this.lead.model}
                                            </span>
                                        </>
                                    )}
                                </h1>
                                {this.lead.confirmStatus ? (
                                    <>
                                        <div className="text-center mt-4 mb-4">
                                            <a
                                                href="/#"
                                                title="Sanction letter"
                                                className="inline-flex items-center openSans-SemiBold no-underline hover:underline blue-link-color hover:text-black text-sm md:text-base"
                                            >
                                                <span className="mr-2">
                                                    <img
                                                        className="object-cover"
                                                        src={mailIcon}
                                                        alt="Sanction letter"
                                                        title="Sanction letter"
                                                    />
                                                </span>
                                                Sanction letter
                                            </a>
                                        </div>

                                        <h2 className="openSans-Reg text-black mt-4 mb-4 md:mt-8 md:mb-8 text-2xl md:text-3xl xl:text-4xl">
                                            Loan Details
                                        </h2>
                                    </>
                                ) : (
                                    <>
                                        <div className="flex items-first md:items-center justify-center my-8 py-2 px-2 rounded-md text-track light-red w-11/12 md:w-8/12 mx-auto text-sm">
                                            <span className="mr-3 icon-minw">
                                                <img
                                                    className="object-cover"
                                                    src="images/icon-alert.png"
                                                    alt="Alert icon"
                                                    title="Alert icon"
                                                />
                                            </span>
                                            Lorem ipsum dolor sit amet,
                                            consectetur ading elit, sed do
                                            eiusmod tempor incididunt ut labore
                                            et magna aliqua.
                                        </div>
                                        <p className="openSans-Light text-center text-base sm:text-xl md:text-2xl">
                                            Contact your nearest branch for more
                                            details
                                        </p>
                                        <div className="w-full my-8 mx-auto text-center">
                                            <button
                                                onClick={() =>
                                                    this.props.history.push(
                                                        "offer"
                                                    )
                                                }
                                                className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white  py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue openSans-SemiBold mb-2 transition-all"
                                            >
                                                Restart Loan Application
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        {this.lead.confirmStatus ? (
                            <LoanConfirmationDetail />
                        ) : (
                            ""
                        )}
                    </section>
                </div>
            </>
        );
    }
}

export default Confirmation;
